export const getCountryCode = async () => {
  try {
    const response = await fetch('https://ipinfo.io/json', { method: 'GET' })
    return await response.json()
  } catch (error) {
    console.error('Error fetching the country code:', error)
    return null
  }
}

export const EU_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
])

export function isEU(countryCode?: string | null) {
  return EU_COUNTRIES.has(String(countryCode || '').toUpperCase())
}

export const getRegionUrl = (region: string, url: string) => {
  if (region === 'US') {
    return '/us/' + url
  }

  if (region === 'EU') {
    return '/eu/' + url
  }

  return '/' + url
}
